import { defineComponent as _defineComponent } from 'vue'
import { inject, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiDisclosurePanel',
  setup(__props) {

const isOpen = inject('isOpen') as Ref<Boolean>;

return { __sfc: true,isOpen }
}

})